import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

function Redirect() {
  const { id, userEmail, token } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      localStorage.setItem("id", id);
    }
    if (userEmail) {
      localStorage.setItem("userEmail", userEmail);
    }
    if (token) {
      localStorage.setItem("token", token);
    }
    if (id || userEmail || token) {
      navigate("/login");
    }
  }, [id, userEmail, token, navigate]);

  return null; // No UI needed
}

export default Redirect;
